<template>
	<el-container id="zuoye">
		<div class="titBox">
			<p class="tit">我的作业</p>
			<div class="titRightBox">
				<ul class="qi" :class="$store.state.qiFocus" @click="qiClick">
					<i class="iconfont">&#xe610;</i>
					<li @click.stop="qiClick(0)" :class="qiNum==0?'act':''">全部学期</li>
					<li v-for="(index,i) of qiCount" :key="i" @click.stop="qiClick(index)" :class="qiNum==index?'act':''">第{{qiZh(index)}}学期{{"（"+kaixue(index, qiDang)+"）"}}</li>
				</ul>
			</div>
		</div>
		<div class="zuoyeBox">
			<el-table ref="topicTable" :data="tableData" header-row-class-name="kbHead" class="zuoyeTab" v-loading="loading" :row-key="getRowKeys">
    			<el-table-column type="expand" width="1" class-name="expand">
					<template slot-scope="props">
						<div class="exs_item" v-for="(item, index) in props.row.exercises" :key="index" v-if="item.question_num">
							<i class="iconfont">&#xe66c;</i>
							<div class="exs_box">
								<div class="exs_tit">{{item.title}}</div>
								<ul class="exs_info">
									<li>题数：{{item.question_num}}</li>
									<li>作业得分：<font :color="last_score_color(parseInt(item.last_score))">{{item.last_score}}</font></li>
									<li>完成时间：{{item.last_time ? item.last_time : '-'}}</li>
								</ul>
							</div>
							<el-button class="check_result" type="text"
							:class="item.last_log_id == 0 ? 'disabled' : ''"
							@click.native.prevent="check_exercise(item, props.row)">
								查看作业
							</el-button>
							<el-button class="exs_start" @click.native.prevent="join_exercise(item, props.row)" type="text">
								开始答题
							</el-button>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="title" class-name="title" label="课程名称"></el-table-column>
				<el-table-column prop="progress" align="center" label="完成进度" width="180" :formatter="jinduCon"></el-table-column>
				<el-table-column prop="task_count" align="center" label="作业数量" width="100"></el-table-column>
				<el-table-column class-name="ctrl" align="center" label="操作" width="280">
					<template slot-scope="props">
						<el-button @click.native.prevent="toggleRowExpansion(props)" type="text">查看作业
							<i class="iconfont">&#xe610;</i>
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="nodata" v-if="!tableData">
				<img :src="nodataImg">
				<p>暂无内容</p>
			</div>
		</div>
	</el-container>
</template>

<script>
export default {
	name: 'kebiao'
	,data () {
		return {
			qiNum:0
			,qiDang:0
			,qiCount:0
			,loading:true
			,tableData:[]
			,expand_id:''
		}
	}
	,mounted:function(){
		var that=this

		//获取用户数据
		this.$selfjs.getUserCallFn(this,function(res){
			that.qiDang = res.term				//当前学期
			that.qiNum = res.term				//现在选择的学期数
			that.qiCount = res.term_count		//学期数

			//获取课程表
			that.getKebiao( res.term)
		})
	}
	,methods:{
		jinduCon(row, column, cellValue, index){
			// console.log(row, column, cellValue, index)
			return cellValue+"%";
		},
		//学期中文字返回
		qiZh(i){
			return this.$selfjs.qiZh(i)
		},
		//学期是否已开学
		kaixue(i, dang){
			if(i==dang){
				return '当前学期'
			}else if(i>dang){
				return '未开学'
			}else if(i<dang){
				return '已完成学期'
			}
		},
		//学期选择点击
		qiClick(num){
			var that=this
			this.$selfjs.qiSelect(this,{num:num}, function(option){
				that.qiNum=option.num
				that.loading=true
				
				//获取课程表
				that.getKebiao( num)
			})
		},
		//获取课程表
		getKebiao(term){
			var token=this.$cookies.get("token")
				,serverSrc=this.global.serverSrc
				,qianzui=this.global.qianzui
				,that = this
			this.$ajax.get(serverSrc + qianzui + "/tasks/myCourseTasks",{
				params:{
					term:term
					,with: 'exercises'
					,pagsize:999
				}
			})
			.then(function(res){
				let resData=res.data
					,kbArr=[]
				if(resData.code==0){
					let kbData=resData.data
					for(let k=0;k<kbData.length;k++){
						kbArr.push(Object.assign(kbData[k],{
							expand: false
						}))
					}
					that.tableData=kbArr
				}else{
					that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
				}
			})
			.catch(err=>{
				console.log(err);
			})
		},
		toggleRowExpansion(props) {
			let row = props.row
			this.$refs.topicTable.toggleRowExpansion(row, !row.expand) // 点击button展开
			this.tableData[props.$index].expand = !row.expand
		},
		getRowKeys(row) {
			return row.id
		},
		last_score_color(score){
			if(score == 0){
				return "#999"
			}else if(score>=60){
				return '#0586ec'
			}else{
				return '#f00'
			}
		},
		//题库练习跳转
		join_exercise(item, row){
			//跳转到考试页
			this.global.join_kaoshi.switch = true
			this.$router.push({
				path: '/web/courseInfo/exercise',
				name: 'exercise',
				query: {
					courseId: row.id,
					type: 'exercises',
					type_id: item.id,
					test_id: item.id
				},
				params: ''
			})	
		},
		//题库练习查看
		check_exercise(item, row){
			if(!item.last_log_id){
				return false
			}
			let data = {
				courseId: row.id,
				type: "exercises",
				type_id: item.id,
				test_id: item.id,
				log_id: item.last_log_id,
				result: ''
			}
			// 跳转到题目解析页
			this.$router.push({
				path: '/web/courseInfo/exercise_err',
				name: 'exercise_err',
				query: data,
				params: ''
			})
		},
	},
	watch:{
		tableData:function(){
			this.$nextTick(function () {
				this.loading=false;
			})
		}
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/renwu/zuoye.vue